import React, { useState } from 'react'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ToolTipText } from './styles'

const ToolTip = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false)
  return (
    <Button onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
      <FontAwesomeIcon icon={faQuestionCircle} />
      {isVisible && <ToolTipText>{children}</ToolTipText>}
    </Button>
  )
}

export default ToolTip
